// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_VersaoAgenteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /chamados/versao-agente
 *
 * `versao` é a tag da plataforma que entrega o que o agente implementou
 * (`v1.117.10`); vazio LIMPA. Não há campo de autor nem de data: quem gravou é
 * o JWT e quando é o servidor. O formato é conferido aqui; que a tag exista de
 * fato não — quem grava é o agente, logo depois de cortá-la.
 */
import { registerContract } from './validate'

export interface Chamados_VersaoAgenteInput {
chamado_id: number
versao?: string
}

registerContract('Chamados_VersaoAgenteInput', {
  chamado_id: { type: 'number',  required: true },
  versao:     { type: 'string',  required: false },
})
